import { globalAxiosInstance } from "../../../apiCalls/utils/axios";
import { makeRequest } from "../../../apiCalls/utils/makeRequest";
import { RawVehicleTemplate } from "../typings/RawVehicleTemplate";
import { VehicleTemplate } from "../facades/VehicleTemplate";

type GetVehiclesTemplatesResponse = {
  data: RawVehicleTemplate[];
};

type GetVehiclesTemplatesRequest = {
  query?: string;
  orderBy?: string;
  order?: "asc" | "desc";
  filters?: { id: string; value: string; type: string }[];
};

const mappingIds = {
  name: "name",
  companies: "companies",
};

export const useGetVehicleTemplates = makeRequest({
  baseUrl: process.env.REACT_APP_VEHICLES_API || "",
  buildQuery: () => "/vehicles/templates",
  axiosInstance: globalAxiosInstance,
  method: "get",
  withInitialLoading: true,
  buildParams: (params: GetVehiclesTemplatesRequest) => ({
    q: params.query,
    order_by: params.orderBy,
    order: params.order,
    filters: params.filters
      ?.map(({ id, value, type }) => `${mappingIds[id] || id}:${type}:${value}`)
      ?.join(";"),
  }),
  transformResponse: (response: GetVehiclesTemplatesResponse) =>
    response.data.map((template) => new VehicleTemplate(template)),
});

